module.exports = __webpack_public_path__ + "img/setup.71563571.svg";